import React, { Component } from "react";

export const userList = {
  showPagination: true,
  columns: [
    { Header: "Role", accessor: "role", sortable: false },
    {
      Header: "Sites",
      accessor: "sites",
      sortable: false,
      editable: true,
      Cell: (row) => {
        return row.original.sitecount > 0 ? (
          <div>
            {row.original.sites}{" "}
            {!row.original.siteclicked ? (
              <a
                onClick={(e) => row.original.LinkClicked(e, row.original)}
                id="site"
              >
                + {row.original.sitecount} more
              </a>
            ) : (
              ""
            )}
          </div>
        ) : (
          <div>{row.original.sites}</div>
        );
      },
    },
    { Header: "Email Address", accessor: "email", sortable: false },
    { Header: "Phone Number", accessor: "phonenumber", sortable: false },
  ],
};
export const addUser = {
  className: "AddUser",
  fields: [
    {
      type: "heading",
      label: "Fill the below information to add user",
    },
    {
      type: "input",
      name: "firstname",
      label: "First Name",
      value: "",
      required: true,
    },
    {
      type: "input",
      name: "lastname",
      label: "Last Name",
      value: "",
      required: true,
    },
    {
      type: "input",
      name: "email",
      label: "Email Address",
      value: "",
      required: true,
    },
    {
      type: "input",
      name: "phonenumber",
      label: "Phone Number",
      value: "",
      required: true,
    },

    {
      type: "staticSelect",
      name: "role",
      label: "Role",
      value: "",
      required: true,
      data: [
        { id: "ADMIN", name: "Administrator" },
        { id: "ASSISTANT", name: "Assistant" },
        { id: "PHYSICIAN", name: "Physician" },
        { id: "SALESREP", name: "Sales Representative" },
      ],
    },
    // {
    //   type: "toggle",
    //   name: "istrained",
    //   label: "Is Trained?",
    //   value: false,
    // },
    {
      type: "checkbox",
      name: "sendwelcomeemail",
      label: "Send Welcome Email",
      value: true,
    },
    {
      type: "heading",
      label: "Sites",
    },
    {
      type: "content",
      name: "SitesName",
      required: true,
    },
  ],
  validations: {
    firstname: (e) => {
      let re = new RegExp("[a-zA-Z]");
      if (e === "") {
        return {
          valid: false,
          errMsg: "First Name is mandatory.",
        };
      }
      if (re.test(e) === false) {
        return {
          valid: false,
          errMsg: "First Name must have alphabets only.",
        };
      }
      return {
        valid: true,
      };
    },
    lastname: (e) => {
      let re = new RegExp("[a-zA-Z]");
      if (e === "") {
        return {
          valid: false,
          errMsg: "Last Name is mandatory.",
        };
      }
      if (re.test(e) === false) {
        return {
          valid: false,
          errMsg: "Last Name must have alphabets only.",
        };
      }
      return {
        valid: true,
      };
    },
    email: (e) => {
      let re = RegExp(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
      if (e === "") {
        return {
          valid: false,
          errMsg: "Email Address is mandatory.",
        };
      }
      if (re.test(e) === false) {
        return {
          valid: false,
          errMsg: "Email Address is invalid.",
        };
      }
      return {
        valid: true,
      };
    },
    phonenumber: (e) => {
      // let re = /(([+][(]?[0-9]{1,3}[)]?)|([(]?[0-9]{4}[)]?))\s*[)]?[-\s\.]?[(]?[0-9]{1,3}[)]?([-\s\.]?[0-9]{3})([-\s\.]?[0-9]{3,4})/;
      let re = /^[0-9\s!@#$%^&*()_\-+=-`~\\\]\[{}|';:/.,?><]*$/;
      if (e === "") {
        return {
          valid: false,
          errMsg: "Phone Number is mandatory.",
        };
      }
      if (!re.test(e)) {
        return {
          valid: false,
          errMsg: "Phone Number is invalid.",
        };
      }
      if (e.length > 20) {
        return {
          valid: false,
          errMsg: "Phone Number is invalid.",
        };
      }
      return {
        valid: true,
      };
    },
    role: (e) => {
      if (e === "") {
        return {
          valid: false,
          errMsg: "Role is mandatory.",
        };
      }
      return {
        valid: true,
      };
    },
  },
  contentValidation: {
    SitesName: true,
  },
  conditionBasedConfiguration: {
    role: (e) => {
      if (e === "ADMIN") {
        return addUser.fields.filter(
          (item) => item.name !== "SitesName" && item.label !== "Sites"
        );
      } else {
        let addUserFields = addUser.fields;
        addUserFields = addUser.fields.filter(
          (items) => items.label === "Sites"
        ).length
          ? addUser.fields
          : addUser.fields.push({ type: "heading", label: "Sites" });
        addUserFields = addUser.fields.filter(
          (items) => items.name === "SitesName"
        ).length
          ? addUser.fields
          : addUser.fields.push({
              type: "content",
              name: "SitesName",
              required: true,
            });
        return addUser.fields;
      }
    },
  },
};
export const userData = [
  {
    name: "Ali Asgar",
    role: "Administrator",
    sites: "Fortis Hospital",
    email: "navpreet@qsstechnosoft.com",
    phonenumber: "+91 9971877676",
  },
];
